import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import ContactBlockDsfr from "components/ContactBlockDsfr";
import LanguageContext from "components/LanguageContext";
import SiteContext from "components/SiteContext";
import webcallback from "components/templates/webcallback/webcallback";
import Button from "components/templatesComponents/Button";
import Link from "components/templatesComponents/Link";
import { buttonStyled } from "components/templatesComponents/StyledComponent";
import { useFindPages } from "hooks/page.hook";
import { useGetAllSites } from "hooks/site.hook";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import EulerianService from "services/EulerianService";
import t from "utils/locales/translation.json";

const ContactPhoneBlock = (props) => {
  const { contactPhone = {} } = props;

  const {
    title: contactPhoneTitle,
    description: contactPhoneDescription,
    detail: contactPhoneDetail = {},
  } = contactPhone;

  const {
    icon1,
    phone1,
    icon2,
    phone2,
    icon3,
    phone3,
    deafAccess,
    iconWebcallback,
    webcallback: webcallbackText,
  } = contactPhoneDetail;

  const site = useContext(SiteContext);
  const { id: siteId } = site || {};
  const { language } = useContext(LanguageContext);

  const { data: allSites = [] } = useGetAllSites();

  const antsSite = useMemo(() => allSites?.find((s) => s.name === "ANTS"), [allSites]);

  const { id: antsSiteId, host: antsSiteHost } = antsSite || {};

  const { data: webcallbackPages = [] } = useFindPages({
    siteId: antsSiteId,
    filters: [`template||eq||${webcallback.key}`, `page.lang||eq||${language}`],
  });

  const { fullPath: webcallbackFullPath } = webcallbackPages[0] || {};

  const webcallbackLinkProps = useMemo(() => {
    if (siteId === antsSiteId) {
      return { page: webcallbackPages[0] };
    }
    if (webcallbackFullPath) {
      return { url: `${antsSiteHost}${webcallbackFullPath}` };
    }
    return {};
  }, [siteId, antsSiteId, webcallbackFullPath, antsSiteHost, webcallbackPages]);

  const handleClickDeafAccess = () => {
    EulerianService.sendClick({ button: [`button::click::acces sourds malentendants`] });
  };

  return (
    <ContactBlockDsfr
      leftChild={
        <Stack spacing={3}>
          <h3 id="contactPhone">{contactPhoneTitle}</h3>
          <p className="fr-text--lg">{contactPhoneDescription}</p>
        </Stack>
      }
      rightChild={
        <Stack
          spacing={5}
          sx={{
            "& p": { width: "100%" },
            "& a": { ...buttonStyled, ml: { lg: "36px !important" } },
          }}
        >
          <Stack spacing={4}>
            {phone1?.props?.children && (
              <Stack direction="row" spacing={1.5}>
                {icon1}
                <p className="fr-text--lg">{phone1}</p>
              </Stack>
            )}
            {phone2?.props?.children && (
              <Stack direction="row" spacing={1.5}>
                {icon2}
                <p className="fr-text--lg">{phone2}</p>
              </Stack>
            )}
          </Stack>
          {webcallbackText?.props?.children && (
            <Stack spacing={3}>
              <Stack direction="row" spacing={1.5}>
                {iconWebcallback}
                <p className="fr-text--lg">{webcallbackText}</p>
              </Stack>
              <Button component={Link} basic {...webcallbackLinkProps}>
                {t[language].help.go_webcallback_button}
              </Button>
            </Stack>
          )}
          {phone3?.props?.children && (
            <Stack spacing={3}>
              <Stack direction="row" spacing={1.5}>
                {icon3}
                <p className="fr-text--lg">{phone3}</p>
              </Stack>
              <Box onClick={handleClickDeafAccess}>{deafAccess}</Box>
            </Stack>
          )}
        </Stack>
      }
    />
  );
};

ContactPhoneBlock.propTypes = {
  contactPhone: PropTypes.shape().isRequired,
};

export default ContactPhoneBlock;
